export default __webpack_public_path__ + "static/media/merchant-waysbucks.41cd245c.png";